import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Props, Screen } from '~/components/screens/funnels/custody/whitepaper'
import { site } from '~/config'
import { GetStaticProps } from 'next'
import { serialize } from 'next-mdx-remote/serialize'

const Page: React.FC<Props> = (props) => (
  <>
    <Seo
      title={`Custody Whitepaper | ${site.title}`}
      image={{
        url: `${site.host}/images/funnel/custody/dominos_desktop.webp`,
        height: 811,
        width: 1440,
      }}
    />
    <Screen {...props} />
  </>
)

export default Page

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      trafficSource: 'linkedin',
      hero: {
        blackText: false,
        heroImage: {
          mobile: {
            alt: 'hands holding dominos from falling',
            href: '/images/funnel/custody/dominos_mobile.webp',
          },
          desktop: {
            alt: 'hands holding dominos from falling',
            href: '/images/funnel/custody/dominos_desktop.webp',
          },
        },
      },
      heroContent: await serialize(heroMdx),
      bodyContent: await serialize(bodyMdx),
    },
  }
}

const heroMdx = `
# **Better frameworks for better custody.**

Custodia is built differently, so that you can read headlines without worrying about your future. Learn more about our segregated custody model for Bitcoin and its unique, heightened protections.
`

const bodyMdx = `
### Custodia offers a regulatory-compliant platform for institutions to transact across digital assets and the traditional financial system. We’re now accepting applications for Bitcoin custody and also other traditional financial products.\\*

You might have some questions, for example:

- Why is Custodia a bank?
- What is a segregated custody model and what advantages does it offer over an omnibus custody model? 
- How does Custodia maximize clarity of property rights for its customers?
- What is “bailment” and why does it matter?

Our whitepaper provides detailed answers to these questions and more. By completing this form, you are consenting to have Custodia contact you and tell you more about our services. Learn more about our [Privacy](/legal/privacy-notice) policy and [Terms of Service](/legal/terms-of-service).

## About Custodia

Custodia is a bank that operates under a special purpose depository institution legal and regulatory framework in the United States. This allows us to offer a full suite of financial services for both U.S. dollars\\* and digital assets that is tailored to business customers looking for enhanced regulatory clarity, defined property rights for assets, and minimized transactional risk.

Custodia services business customers such as:

- Digital asset businesses
- Fintechs  
- Banks
- Corporate treasurers
- Trusts
- Pension Funds
- Endowments
- Foundations
- Start-ups
- and many other types

Custodia looks forward to learning about your needs and helping you solve your business problems.

<sub>\\*Deposits at Custodia are not insured by the FDIC (Federal Deposit Insurance Corporation).</sub>
`
